import type { Faq } from '../types/content'

export const faqs: Faq[] = [
  {
    q: 'How do I receive the package after purchasing?',
    a: 'You’ll receive immediate access to all the material so you can start using it right away — no waiting, no complicated steps.',
  },
  {
    q: 'What level of pickleball instructor is this designed for?',
    a: 'This system works for instructors at every level — whether you’re just starting out or you’ve been coaching for years. The progressions cover beginner through advanced players, and Volume 6 specifically supports your development as an instructor regardless of your experience.',
  },
  {
    q: 'Does this work for pickleball instructors in any country?',
    a: 'Yes. The material is entirely digital and works anywhere in the world. You can start using it today regardless of where you’re located.',
  },
  {
    q: 'Can I edit the material?',
    a: 'The system is delivered in PDF format and is designed to be used as-is — structured, complete, and ready to teach. It is not licensed for resale or redistribution.',
  },
  {
    q: 'What currency will I pay in?',
    a: 'The price adapts automatically to your local currency based on your country at checkout.',
  },
  {
    q: 'What if it doesn’t work for me?',
    a: 'You’re covered by a complete 7-day money-back guarantee. If it’s not right for you, contact us and we’ll refund you in full — no questions asked.',
  },
]
